import { combineReducers } from "redux"
import counterReducer from "./counterReducer"
import initialDataChanged from "./initialDataChangedReducer"
import initialDataReducer from "./initialDataReducer"
import setServiceReducer from "./setServiceReducer"
import initialCommentsDataReducer from "./initialCommentsDataReducer"
import transportInfoReducer from "./transportInfoReducer"
import initialDestinationDataReducer from "./initialDestinationDataReducer"
import setRemoveBookingFromServiceReducer from "./setRemoveBookingFromServiceReducer"
import footerStatusReducer from "./footerStatusReducer"
import serviceTypesReducer from "./serviceTypesReducer"
import activateBookingByQRReducer from "./activateBookingByQRReducer"
import dispatchServiceReducer from "./dispatchServiceReducer"
import retryDispatchServiceReducer from "./retryDispatchServiceReducer"
import postTransportChangeReducer from "./postTransportChangeReducer"
import footerCountersRefreshReducer from "./footerCountersRefreshReducer"
import activateServiceReducer from "./activateServiceReducer"
import addServiceBookingReducer from "./addServiceBookingReducer"
import createServiceReducer from "./createServiceReducer"
import postServiceCommentsReducer from "./postServiceCommentsReducer"
import getUnassignedBookingsReducer from "./getUnassignedBookingsReducer"
import paxReducer from "./paxReducer"
import realtimeUpdateServiceReducer from "./realtimeUpdateServiceReducer"
import deleteBookingReducer from "./deleteBookingReducer"
import changeHeaderExtraServicesReducer from "./changeHeaderExtraServicesReducer"
import masterDataVersionCheckReducer from "./masterDataVersionCheckReducer"
import getDepartureServiceReducer from "./getDepartureServiceReducer"
import getDeparturesFooterStatusReducer from "./getDeparturesFooterStatusReducer"
import getDepartureBookingReducer from "./getDepartureBookingReducer"
import getDropdownFilterDataReducer from "./getDropdownFilterDataReducer"
import departureFooterCountersRefreshReducer from "./departureFooterCountersRefreshReducer"
import getOperationTypesDataReducer from "./getOperationTypesDataReducer"
import realtimeUpdateDepartureReducer from "./realtimeUpdateDepartureReducer"
import realtimeDeparturePositionReducer from "./realtimeDeparturePositionReducer"
import arriveServiceReducer from "./arriveServiceReducer"
import getDepartureUABookingsReducer from "./getDepartureUABookingsReducer"
import postShowBookingReducer from "./postShowBookingReducer"
import postNoShowBookingReducer from "./postNoShowBookingReducer"
import endDepartureServiceReducer from "./endDepartureServiceReducer"
import startDepartureServiceReducer from "./startDepartureServiceReducer"
import showToastReducer from "./showToastReducer"
import realtimeUnassignedBookingNotificationReducer from "./realtimeUnassignedBookingNotificationReducer"
import getVehicleContractsReducer from "./getVehicleContractsReducer"
// TODO get-unassigned-services, post-service, add-service-booking
export default combineReducers({
  counter: counterReducer,
  initialData: initialDataReducer,
  initialService: setServiceReducer,
  userInitialData: initialDataChanged,
  commentsData: initialCommentsDataReducer,
  transportInfo: transportInfoReducer,
  destinationData: initialDestinationDataReducer,
  removeBookingFromService: setRemoveBookingFromServiceReducer,
  footerStatus: footerStatusReducer,
  serviceTypes: serviceTypesReducer,
  activateBookingByQR: activateBookingByQRReducer,
  dispatchService: dispatchServiceReducer,
  retryDispatchService: retryDispatchServiceReducer,
  postTransportChange: postTransportChangeReducer,
  footerCountersRefresh: footerCountersRefreshReducer,
  departureFooterCountersRefresh: departureFooterCountersRefreshReducer,
  activateServiceReducer: activateServiceReducer,
  addServiceBookingReducer: addServiceBookingReducer,
  createServiceReducer: createServiceReducer,
  postServiceCommentsReducer: postServiceCommentsReducer,
  getUnassignedBookingsReducer: getUnassignedBookingsReducer,
  paxReducer: paxReducer,
  deleteBookingReducer: deleteBookingReducer,
  changeHeaderExtraServicesReducer: changeHeaderExtraServicesReducer,
  realtimeUpdateService: realtimeUpdateServiceReducer,
  realtimeUpdateDeparture: realtimeUpdateDepartureReducer,
  realtimeDeparturePosition: realtimeDeparturePositionReducer,
  masterDataVersionCheck: masterDataVersionCheckReducer,
  getDepartureService: getDepartureServiceReducer,
  getDepartureFooterStatus: getDeparturesFooterStatusReducer,
  getDepartureBookings: getDepartureBookingReducer,
  getDropdownFilterData: getDropdownFilterDataReducer,
  getOperationTypesData: getOperationTypesDataReducer,
  arriveServiceReducer: arriveServiceReducer,
  getDepartureUABookings: getDepartureUABookingsReducer,
  postShowBookingReducer: postShowBookingReducer,
  postNoShowBookingReducer: postNoShowBookingReducer,
  endDepartureServiceReducer: endDepartureServiceReducer,
  startDepartureServiceReducer: startDepartureServiceReducer,
  showToast: showToastReducer,
  realtimeUnassignedBookingNotification: realtimeUnassignedBookingNotificationReducer,
  getVehicleContracts : getVehicleContractsReducer
})
